export { registerCmsOpenSearchStorageOperations } from "./feature.js";
